import { useCallback, useEffect, useState } from "react";
import { ApiError, booksApi, type Me } from "../lib/api";

export function useMe() {
  const [me, setMe] = useState<Me | null>(null);
  const [error, setError] = useState<ApiError | null>(null);
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    setLoading(true);
    try { setMe(await booksApi.me()); setError(null); }
    catch (e) { setError(e instanceof ApiError ? e : new ApiError(String(e))); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { void load(); }, [load]);
  return { me, error, loading, reload: load };
}

const LAST = "books.lastCompany";
// the company this tab works in (the address doesn't carry it): this tab's choice, else the last one chosen anywhere
export const lastCompany = {
  get(): string | null {
    try { return sessionStorage.getItem(LAST) ?? localStorage.getItem(LAST); } catch { return null; }
  },
  set(id: string) {
    try { sessionStorage.setItem(LAST, id); } catch { /* private window */ }
    try { localStorage.setItem(LAST, id); } catch { /* private window */ }
  },
  clear() { try { sessionStorage.removeItem(LAST); localStorage.removeItem(LAST); } catch { /* private window */ } },
};
